import { React, useState } from "react";
import "./index.css";
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import image from  "./img/switch.png";
import imagebk from  "./img/back.png";
import logoutimg from "./img/logout.png";
import Buttons from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {ASSERT_CREATE,ASSERT_REQUEST,ASSERT_LIST,ASSERT_REQUEST_LIST,ASSERT_ASSIGN} from "../../Pages/AppConstant";

function Landing() {
    const [emp_id, setEmp_id] = useState("");
    const [emp_fullname, setEmp_fullname] = useState("");
    const [emp_displayname, setEmp_displayname] = useState("");
    const [grade, setGrade] = useState("");
    const [designation, setDesignation] = useState("");
    const [department, setDepartment] = useState("");
    const [contact, setContact] = useState("");
    const [typeofhire, setTypeofhire] = useState("");
    const [worklocation, setWorklocation] = useState("");
    const [email_id, setEmail_id] = useState("");    
    const [doj, setDoj] = useState("");
    const [asset_id,setAsset_id] =  useState("");
    const [make,setMake] = useState("");
    const [selectedcategory,setSelectedcategory] = useState("");
    const [serialno,setSerialno] = useState("");
    const [dop,setDop] = useState("");
    const [os,setOs] = useState("");
    const [processor,setProcessor] = useState("");
    const [ram,setRam] = useState("");
    const [hdd,setHdd] = useState("");
    const [model,setModel] = useState("");
    const [isfirsttab,setIsfirsttab] = useState(false)
    const [issecondtab,setIsecondtab] = useState(true)
    const [isthirdtab,setIsthirdtab] = useState(false)
    const [isforthtab,setIsforthtab] = useState(false)
    const [assetlist,setAssetlist] = useState([]);
    const [requestlist,setRequestlist]= useState([]);
    const [show, setShow] = useState(false);
    const [selectedasset,setSelectedasset] = useState([])
    const [rawdata,setRawdata]= useState([])
    const [selectedempid,setSelectedempid] = useState("")
    const [selectedemailid,setSelectedemailid] = useState("")
    const [empdata,setEmpdata] = useState("")
   
   

    const handleSubmit = (e) => {
        e.preventDefault();       
        if(!emp_id||!emp_fullname||!emp_displayname||!grade||!designation||!department||!email_id||!typeofhire||!worklocation||!doj){
            alert("Please fill all the fields")
        }else{
            getUserData(emp_id);
            
        }
        // Add your form submission logic here
        
    };
    const assetSubmit=(e)=>{
        e.preventDefault();       
        if(!asset_id||!make||!selectedcategory||!serialno||!dop||!os||!processor||!ram||!hdd||!model){
            alert("Please fill all the fields")
        }else{
            getcreateasset(asset_id);
            
        }
    }
    const getcreateasset=()=>{ 
        let category = selectedcategory
        let serial_no = serialno
        let processor_no = processor
        let hdd_ssd = hdd
        let date_of_purchase = dop
        let stock = "Not Assigned"
        axios.post(ASSERT_CREATE, {asset_id,make,category,serial_no,os,date_of_purchase,processor_no,ram,hdd_ssd,model,stock})
          .then(function (response) {
            console.log("SuccessFully created");
            alert(response.data);
            handleResetasset();
          })
          .catch(function (error) {
            console.log(error);
          });
    }
    const redirectToLogin = ()=>{
        window.location.href = "/login"
    }
    const redirectTodashboard = ()=>{
        window.location.href = "/landingPage"
    }
    
    
     const handleReset = () => {
        // Reset all state variables here
        setEmp_id("");
        setEmp_fullname("");
        setEmp_displayname("");
        setContact("");
        setGrade("")
        setDesignation("")
        setDepartment("")
        
    };
    const handleResetasset =()=>{
        setAsset_id("");
        setMake("");
        setSelectedcategory("");
        setSerialno("");
        setDop("")
        setOs("")
        setProcessor("")
        setRam("")
        setHdd("")
        setModel("")
    }
    const getUserData = ()=>{     
       
        let mobile_number= parseInt(contact)
        let date_of_join= doj
        let remarks="Need to Assign asset"
        
        axios.post(ASSERT_REQUEST, {emp_id,emp_fullname,emp_displayname,grade,designation,department,email_id,mobile_number,typeofhire,worklocation,date_of_join,remarks})
          .then(function (response) {
            console.log("SuccessFully created");
            alert(response.data);
            handleReset();
          })
          .catch(function (error) {
            console.log(error);
          });
       
    }
    const enabletab=(e)=>{
        if(e===1){
            if(!isfirsttab){
                setIsfirsttab(true)
                setIsecondtab(false)
                setIsthirdtab(false)
                setIsforthtab(false)
            }
        }else if(e===2){
            setIsfirsttab(false)
            setIsecondtab(true)
            setIsthirdtab(false)
            setIsforthtab(false)
        }else if(e===3){
            fetchAllData()
            setIsfirsttab(false)
            setIsecondtab(false)
            setIsthirdtab(true)
            setIsforthtab(false)
        }else if(e===4){
            fetchAllData()
            fetchAllrequest()
            setIsfirsttab(false)
            setIsecondtab(false)
            setIsthirdtab(false)
            setIsforthtab(true)
        }
        
    }
    const fetchAllData = () =>{
        axios({
            method: 'get',
            url: ASSERT_LIST,
            withCredentials: false,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded','Access-Control-Allow-Origin' : '*' },
          }).then(response => {
            setAssetlist(response.data.data);
        })
        .catch(error => {
            console.error(error);
        });
    }

    const fetchAllrequest = () =>{
        axios({
            method: 'get',
            url: ASSERT_REQUEST_LIST,
            withCredentials: false,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded','Access-Control-Allow-Origin' : '*' },
          }).then(response => {
            const winCount = localStorage.getItem('Name');
            console.log(winCount)
            setRequestlist(response.data.data);
        })
        .catch(error => {
            console.error(error);
        });
    }

    const clickAction=(val,data)=>{
        handleShow(val,data);
    }

    const handleClose = () => setShow(false);
    const handlesave = ()=>{
        let emp_id = selectedempid;
        let email_id = selectedemailid;
        let asset_id = selectedasset;
        let rawdata = empdata;
       
        axios.post(ASSERT_ASSIGN, {emp_id,email_id,asset_id,rawdata})
          .then(function (response) {
            //console.log("SuccessFully updated");
            alert(response.data.message);
            handleReset();
            fetchAllrequest()
            setShow(false);

          })
          .catch(function (error) {
            console.log(error);
          });
    }
  const handleShow = (e,data) => {
    setRawdata(e)
    setSelectedempid(data.emp_id)
    setSelectedemailid(data.email_id)
    setEmpdata(data) 

    setShow(true);
  }
    return (
        <div className="bg_set"> 
        
        <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Assign Asset</Modal.Title>
        </Modal.Header>
        <Modal.Body><div className="row">
                        <div className="col-md-6"> <label>Select Asset</label></div>
                        <div className="col-md-6"> <select
                        name="select"
                        id="select"
                        value={selectedasset}
                        onChange={(e) =>
                            setSelectedasset(
                                e.target.value
                            )
                        }
                    >
                        <option
                            value=""
                            disabled
                            selected={selectedcategory === ""}
                        >
                            Select category
                        </option> 
                        {
                        rawdata.length ? rawdata.map((val)=>{
                            return(
                               val.stock==="Not Assigned"?
                                <option value={val.asset_id}>{val.asset_id}</option>:''
                            )
                            }) : ''
                    }                  
                            
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}
                       
                        </select></div>
                        </div></Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handlesave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
           
         <div className="switch" >
                    <img className="switch-back" onClick={redirectTodashboard} src={imagebk}/>
                    <img className="switch-img" src={image}/>
                    <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
                </div><br/><br/>         
             <div>
            </div>
            <div>
            <div className="row tabdesign">
            {/* <div className={isfirsttab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(1)}>Create User request</div> */}
            <div className={issecondtab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(2)}>Assets master</div>
            <div className={isthirdtab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(3)}>View Assets master</div>
            <div className={isforthtab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(4)}>Assign assets</div>
            {/* <div className="col-md-2 tabfour">View Request</div> */}
             </div>    
                 {/* table content  */}                 

         {isforthtab?<div className="assettable row" style={{width:'80%',marginLeft:"4%",height:"70vh",overflow:"auto"}}>
            <table className="table-full">
                <thead className="header-asset">
                    <tr>
                        <th>Employee ID</th>
                        <th>Employee Name</th>
                        <th>Display Name</th>
                        <th>DOJ</th>
                        <th>Grade</th>
                        <th>Department</th>
                        <th>Designation</th>
                        <th>Mobile</th>
                        <th>Email id</th>
                        <th>Work Location</th>
                        <th>Type of Hire</th>
                        <th>Asset ID</th>
                        <th>Remarks</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        requestlist.length ? requestlist.map((val,i)=>{
                            return(
                            <tr>
                                <td>{val.emp_id}</td>
                                <td>{val.emp_fullname}</td>
                                <td>{val.emp_displayname}</td>
                                <td>{val.date_of_join}</td>
                                <td>{val.grade}</td>
                                <td>{val.designation}</td>
                                <td>{val.department}</td>
                                <td>{val.mobile_number}</td>
                                <td>{val.email_id}</td>
                                <td>{val.worklocation}</td>
                                <td>{val.typeofhire}</td>
                                <td>{val.asset_id!==null && val.asset_id!==""?val.asset_id:"Not Assigned"}</td>
                                <td style={{backgroundColor:val.remarks==="User Acknowledged"?"chartreuse": val.remarks==="Need to Assign asset"?"orange":'yellow'}}>
                                {val.remarks}
                                </td>
                                <td>
                                {val.remarks==="Need to Assign asset"? <input type="button" className="approve-submitBtn"  value="Assign" onClick={(e)=>clickAction(assetlist,val)}/>:<input type="button" disabled className="approve-submitBtn" value="Assign" onClick={(e)=>clickAction(assetlist,val)}/>}                          
                                
                                <i className="fa fa-tasks" aria-hidden="true"></i></td>
                            </tr>
                            )
                            }) : ''
                    }
                </tbody>
            </table>
        </div>:''}
        {isthirdtab?<div className="assettable row" style={{width:'80%',marginLeft:"4%",height:"70vh",overflow:"auto"}}>
            <table className="table-full">
                <thead className="header-asset">
                    <tr>
                        <th>Asset ID</th>
                        <th>Make</th>
                        <th>Model</th>
                        <th>category</th>
                        <th>serial No</th>
                        <th>Date of purchase</th>
                        <th>OS</th>
                        <th>processor No</th>
                        <th>RAM</th>
                        <th>HDD/SSD</th>
                        <th>Stock</th>
                    </tr>
                </thead>
                <tbody>
                
                    {
                        assetlist.length ? assetlist.map((val)=>{
                            return(
                            <tr>
                                <td>{val.asset_id}</td>
                                <td>{val.make}</td>
                                <td>{val.model}</td>
                                <td>{val.category}</td>
                                <td>{val.serial_no}</td>
                                <td>{val.date_of_purchase}</td>
                                <td>{val.os}</td>
                                <td>{val.processor_no}</td>
                                <td>{val.ram}</td>
                                <td>{val.hdd_ssd}</td>
                                <td>{val.stock}</td>
                                

                                {/* <td>{Moment(val.created_timestamp).format('DD-MM-YYYY')}</td>
                                <td>{Moment(val.from_date).format('DD-MM-YYYY')}</td>
                                <td>{Moment(val.to_date).format('DD-MM-YYYY')}</td> */}
                                {/* <td>{val.duration}</td>
                                <td>{val.leave_reason}</td> */}
                                {/* <td><input type="button" className="approve-submitBtn" value="Approve" onClick={(e)=>clickAction(val,"Approved")}/>&nbsp;&nbsp;<input className="approve-cancelBtn" type="button" value="Reject" onClick={(e)=>clickAction(val,"Rejected")}/></td> */}
                            </tr>
                            )
                            }) : ''
                    }
                </tbody>
            </table>
        </div>:''}
        {/* End of Table content */}
        {isfirsttab?<div className="Apps-asset">
            <p className="Headings">User Request</p>
            <fieldset>
                    <form action="#" method="get">
                    <div className="row spacing">
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label for="employeeid">
                        Employee ID
                        </label></div>
                        <div className="col-md-6"><input
                            type="text"
                            name="employeeid"
                            id="employeeid"
                            value={emp_id}
                            onChange={(e) =>
                                setEmp_id(e.target.value)
                            }
                            placeholder="Enter Emp ID"
                            required
                        /></div>
                        </div>
                        </div>
                        <div className="col-md-3">
                        <div className="row">
                        <div className="col-md-6">
                        <label for="birthday">DOJ</label></div>
                        <div className="col-md-6">
                            <input type="date"  onChange={(e) =>setDoj(e.target.value)} id="birthday" name="birthday"/>
                            </div></div> </div>
                            <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                        <label for="Employeename">Employee Name</label>
                        </div>
                        <div className="col-md-6">
                        <input
                            type="text"
                            name="Employeename"
                            id="Employeename"
                            value={emp_fullname}
                            onChange={(e) =>
                                setEmp_fullname(e.target.value)
                            }
                            placeholder="Enter Full Name"
                            required
                        />
                            </div></div> </div>  
                        </div>
                        <div className="row spacing">
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label for="lastname">Display Name</label></div>
                        <div className="col-md-6"> 
                        <input
                            type="text"
                            name="lastname"
                            id="lastname"
                            value={emp_displayname}
                            onChange={(e) =>
                                setEmp_displayname(e.target.value)
                            }
                            placeholder="Enter Display Name"
                            required
                        />
                        </div>
                        </div>                   
                        </div>
                        <div className="col-md-3">
                        <div className="row">
                        <div className="col-md-6"><label for="lastname">Grade</label></div>
                        <div className="col-md-6"><input
                            type="text"
                            name="lastname"
                            id="lastname"
                            value={grade}
                            onChange={(e) =>
                                setGrade(e.target.value)
                            }
                            placeholder="Enter Grade"
                            required
                        /></div>
                        </div>                   
                        </div>
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label for="lastname">Department</label></div>
                        <div className="col-md-6"><input
                            type="text"
                            name="lastname"
                            id="lastname"
                            value={department}
                            onChange={(e) =>
                                setDepartment(e.target.value)
                            }
                            placeholder="Enter Department"
                            required
                        /></div>
                        </div>                  
                        </div>
                        </div>
                        <div className="row spacing">
                        <div className="col-md-4">                    
                        <div className="row">
                        <div className="col-md-6"><label for="Designation">
                        Designation
                        </label></div>
                        <div className="col-md-6"> <input
                            type="text"
                            name="Designation"
                            id="Designation"
                            value={designation}
                            onChange={(e) =>
                                setDesignation(e.target.value)
                            }
                            placeholder="Enter Designation"
                            required
                        /></div>
                        </div>
                        </div>
                        <div className="col-md-3">                   
                        <div className="row">
                        <div className="col-md-6"><label for="tel">Mobile</label></div>
                        <div className="col-md-6"> <input
                            type="text"
                            name="contact"
                            id="contact"
                            maxlength="10"
                            value={contact}
                            onChange={(e) =>
                                setContact(e.target.value)
                            }
                            placeholder="Enter Mobile number"
                            required
                        /></div>
                        </div>
                        </div> 
                        <div className="col-md-4">                   
                        <div className="row">
                        <div className="col-md-6"><label for="Email">
                        Email id
                        </label></div>
                        <div className="col-md-6"> <input
                            type="text"
                            name="Email"
                            id="Email"
                            value={email_id}
                            onChange={(e) =>
                                setEmail_id(e.target.value)
                            }
                            placeholder="Enter Email ID"
                            required
                        /></div>
                        </div>
                        </div>
                        </div>
                        <div className="row spacing">
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label for="lastname">Work Location </label></div>
                        <div className="col-md-6"><input
                            type="text"
                            name="lastname"
                            id="lastname"
                            value={worklocation}
                            onChange={(e) =>
                                setWorklocation(e.target.value)
                            }
                            placeholder="Enter work location"
                            required
                        /></div>
                        </div>
                    
                        </div>
                        <div className="col-md-3">
                        <div className="row">
                        <div className="col-md-6"><label for="Hire">
                        Type of Hire
                        </label></div>
                        <div className="col-md-6"><input
                            type="text"
                            name="Hire"
                            id="Hire"
                            value={typeofhire}
                            onChange={(e) =>
                                setTypeofhire(e.target.value)
                            }
                            placeholder="Enter Type of Hire"
                            
                        /></div>
                        </div>
                    
                        </div> 
                        </div>                    
                                    
                        <Button
                            variant="primary"
                            className="btns bts-clear"
                            type="reset"
                            value="reset"
                            onClick={() => handleReset()}
                        >
                            Clear
                        </Button>   
                        <Button
                        variant="primary"
                        className="btns bts-submit"
                            type="submit"
                            value="Submit"
                            onClick={(e) => handleSubmit(e)}
                        >
                            Submit
                        </Button>
                    </form>
            </fieldset>
        </div>:''}
            </div>
        {/* Asset master  */}
        {issecondtab?<div className="Apps-asset">
            <p className="Headings">Asset Master</p>
            <fieldset>
                <form action="#" method="get">
                <div className="row spacing">
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label for="employeeid">
                    Asset ID
                    </label></div>
                        <div className="col-md-6"><input
                        type="text"
                        name="Assetid"
                        id="assetid"
                        value={asset_id}
                        onChange={(e) =>
                            setAsset_id(e.target.value)
                        }
                        placeholder="Enter Asset ID"
                        required
                    /></div>
                        </div>
                        </div>
                        <div className="col-md-3">
                        <div className="row">
                        <div className="col-md-6">
                        <label for="Make">
                    Make
                    </label></div>
                        <div className="col-md-6">
                        <input
                        type="text"
                        name="make"
                        id="make"
                        value={make}
                        onChange={(e) =>
                            setMake(e.target.value)
                        }
                        placeholder="Enter Make"
                        required
                    />
                            </div></div> </div>
                            <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                        <label for="Model">
                    Model
                    </label>
                        </div>
                        <div className="col-md-6">
                        <input
                        type="text"
                        name="Model"
                        id="Model"
                        value={model}
                        onChange={(e) =>
                            setModel(e.target.value)
                        }
                        placeholder="Enter Model"
                        required
                    />
                            </div></div> </div>  
                        </div>

                        <div className="row spacing">
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"> <label>Category</label></div>
                        <div className="col-md-6"> <select
                        name="select"
                        id="select"
                        value={selectedcategory}
                        onChange={(e) =>
                            setSelectedcategory(
                                e.target.value
                            )
                        }
                    >
                        <option
                            value=""
                            disabled
                            selected={selectedcategory === ""}
                        >
                            Select category
                        </option>                        
                            <option value="Laptop">Laptop</option>
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}
                       
                        </select></div>
                        </div>
                        </div>
                        <div className="col-md-3">
                        <div className="row">
                        <div className="col-md-6">
                        <label for="lastname">Serial No.</label></div>
                        <div className="col-md-6">
                        <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={serialno}
                        onChange={(e) =>
                            setSerialno(e.target.value)
                        }
                        placeholder="Enter Serial number"
                        required
                    />
                            </div></div> </div>
                            <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                        <label for="birthday">Date of purchase</label>
                        </div>
                        <div className="col-md-6">
                        <input type="date"  onChange={(e) =>setDop(e.target.value)} id="birthday" name="birthday"/>
                            </div></div> </div>  
                        </div>


                        <div className="row spacing">
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"> <label for="os">
                    OS
                    </label></div>
                        <div className="col-md-6">  <input
                        type="text"
                        name="os"
                        id="os"
                        value={os}
                        onChange={(e) =>
                            setOs(e.target.value)
                        }
                        placeholder="Enter OS"
                        required
                    /></div>
                        </div>
                        </div>
                        <div className="col-md-3">
                        <div className="row">
                        <div className="col-md-6">
                        <label for="processor">
                    Processor No.
                    </label></div>
                        <div className="col-md-6">
                        <input
                        type="text"
                        name="procsssor"
                        id="processor"
                        value={processor}
                        onChange={(e) =>
                            setProcessor(e.target.value)
                        }
                        placeholder="Enter processor No."
                        required
                    />
                            </div></div> </div>
                            <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                        <label for="ram">
                    RAM
                    </label>
                        </div>
                        <div className="col-md-6">
                        <input
                        type="text"
                        name="ram"
                        id="ram"
                        value={ram}
                        onChange={(e) =>
                            setRam(e.target.value)
                        }
                        placeholder="Enter RAM"
                        required
                    />
                            </div></div> </div>  
                        </div>
               
                   
                    
                    
                    <div className="row spacing">
                    <div className="col-md-4">
                    <div className="row">
                        <div className="col-md-6">  <label for="lastname">HDD / SSD </label> </div>
                        <div className="col-md-6">   <input
                        type="text"
                        name="hdd"
                        id="hdd"
                        value={hdd}
                        onChange={(e) =>
                            setHdd(e.target.value)
                        }
                        placeholder="Enter HDD / SSD"
                        required
                    /></div></div>
                  
                  
                    </div>
                    </div>
                    <Button
                        variant="primary"
                        className="btns bts-clear"
                        type="reset"
                        value="reset"
                        onClick={() => handleResetasset()}
                    >
                        Clear
                    </Button>
                    <Button
                    variant="primary"
                      className="btns bts-submit"
                        type="submit"
                        value="Submit"
                        onClick={(e) => assetSubmit(e)}
                    >
                        Submit
                    </Button>
                </form>
            </fieldset>
        </div>:''}
       
        {/*  Modal  */}
       
        </div>
    );
}


export default Landing;
